import { RouteRecordRaw } from 'vue-router'
import { UserRole } from '@/models/user'
import AdminLayout from '@/layouts/AdminLayout.vue'

const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    component: AdminLayout,
    meta: {
      requiresAuth: true,
      requiredRole: UserRole.ADMIN
    },
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: () => import('@/views/admin/Dashboard.vue')
      },
      {
        path: 'stores',
        name: 'admin-stores',
        component: () => import('@/views/admin/StoreManagement.vue')
      },
      {
        path: 'employees',
        name: 'admin-employees',
        component: () => import('@/views/admin/EmployeeManagement.vue')
      },
      {
        path: 'appointments',
        name: 'admin-appointments',
        component: () => import('@/views/admin/AppointmentManagement.vue')
      }
    ]
  }
]

export default adminRoutes 